import { useEffect, useState } from "react";
import { Calendar } from "../../../components/ui/Calendar";
import { TimeSlotSection } from "../../../components/service/TimeSlotSection";
import { el } from 'date-fns/locale';
import useIsMobile from "../../../utils/useIsMobile";
import { TrifoldMapIcon } from "../../../icons";
import { format } from "date-fns";
import clsx from "clsx";
import { getGarageSelectionTitle } from "../serviceUtils";

export const CRMForm = ({ state, dispatch, mode='form' }) => {

  const isMobile = useIsMobile(650)

  // LOCAL STATE: 
  const [daySlots, setDaySlots] = useState([])
  const [availableDays, setAvailableDays] = useState([])
  const [futureDate, setFutureDate] = useState(new Date())

  // FETCH DATA:

  useEffect(()=> {
    const fdate = new Date(state?.calendarData[state?.calendarData?.length - 1]?.startTime)
    setFutureDate(fdate);
  },[state?.calendarData])
  
  // USE EFFECTS:

  useEffect(()=> {
    setDaySlots(getSlotsForDay(
      state?.calendarData,
      state?.calendarValues?.selectedDate
    ))
  },[state.calendarValues.selectedDate, state?.calendarData,])

  useEffect(()=>{
    setAvailableDays(getAvailableDays(state?.calendarData))
  },[state?.calendarData])
  

  // HANDLERS & FUNCTIONS
  
  const getAvailableDays = (slots) => {
    const map = new Map();

    slots.forEach(slot => {
      const date = new Date(slot.startTime);
      const key = date.toLocaleDateString('en-CA');

      if (!map.has(key)) {
        map.set(key, date);
      }
    });

    return Array.from(map.values());
};

  const getSlotsForDay = (slots, selectedDate) => {
    if (!selectedDate) return [];
    return slots.filter(slot => {
      const slotDate = new Date(slot.startTime);
      return slotDate.toDateString() === selectedDate.toDateString();
    });
  };

  
  return (
    <div className='flex flex-col gap-6 pb-8'>
      <h3>1. {getGarageSelectionTitle({state})}</h3>
      <div className={`shadow-md rounded-xl py-6 pl-9 pr-6 ${state?.selectedGarage ? "bg-white":"bg-powdergrey cursor-not-allowed"}`}>
        {state?.selectedGarage ? <>
          <h4 className='pb-3'>{state?.selectedGarage?.garageName}</h4>
          <div className={`flex ${isMobile ? "flex-col gap-4" :"flex-row justify-between items-end"} `}>
            <div className='flex flex-col gap-2'>
              <p className='text-sm'>{state?.selectedGarage?.address}</p>
              <div className="flex flex-row gap-4">
                <button 
                  disabled={!state?.selectedGarage} 
                  className='bg-none flex flex-row gap-2 items-center' 
                  onClick={()=>{
                    const googleMapsUrl = `https://www.google.com/maps/place/${state?.selectedGarage?.coordinates?.lat},${state?.selectedGarage?.coordinates?.lng}`
                    window.open(googleMapsUrl, "_blank", "noopener,noreferrer");           
                  }}>
                    <TrifoldMapIcon className={`w-4 h-4 ${state?.selectedGarage ? "text-primary " : "text-fadedgrey"}`} />
                    <p className={`text-sm ${state?.selectedGarage ? "text-primary " : "text-fadedgrey"} font-semibold`}>Δες το στον χάρτη</p>
                </button>
                {state?.selectedGarage?.distanceFromUser && <p className="text-sm text-grenite">{(state?.selectedGarage?.distanceFromUser/1000).toFixed(1)} km</p>}
              </div>
            </div>
            <button 
              disabled={!state?.selectedGarage} 
              className={`rounded-md py-3 px-11 text-sm font-semibold ${state?.selectedGarage ? 'border border-fadedgrey' : "bg-fadedgrey text-white"}`} 
              onClick={()=>{
                // render different component from parent
                if(state?.stepThree === 'FirstAvailableAvisCalendar') {
                  dispatch({ type: "SET_STEP_THREE", stepThree: "FirstAvailableAvis"});
                } else {
                  if(state?.stepThree === 'CRMForm') {
                    dispatch({ type: "SET_STEP_THREE", stepThree: "CRMFormGarages"});
                  }
                }
              }}>
                Αλλαγή
            </button>
          </div>
        </> : <h4 className='pb-3'>Δεν υπάρχει διαθέσιμο συνεργείο</h4>}
      </div>
      <h3>2. Επιλογή ημερομηνίας & ώρας</h3>
      <div className="bg-white shadow-md rounded-xl py-6 px-9 flex flex-col gap-10">
        <h4>{['PickupCRMForm','CRMForm'].includes(state?.stepThree) ? "Μπορείς να επιλέξεις έως και 3 εναλλακτικές." : "Ποιο ραντεβού σε εξυπηρετεί;"}</h4>
        <div className="grid grid-cols-7 flex-1 min-h-0">
          <div className="col-span-5 h-full">
            <Calendar
              locale={el}
              fromDate={new Date()}
              toDate={futureDate}
              mode="single"
              selected={state.calendarValues.selectedDate}
              onSelect={(date) =>
                dispatch({
                  type: 'SET_SELECTED_DATE',
                  value: date,
                })
              }
              disabled={(date) =>
                !availableDays.some(
                  d => d.toDateString() === date.toDateString()
                )
              }
              modifiers={{
                hasSlot: state.calendarValues.selectedSlots.map(
                  slot => new Date(slot?.date + "T00:00:00")
                )
              }}
              modifiersClassNames={{
                hasSlot: "bg-[#D4002A]/15 rounded-full"
              }}
              className="lg:p-3 py-6 bg-transparent lg:shadow-none rounded-none border border-b-0 border-l-0 border-t-0 border-r-fadedgrey"
              classNames={{
                row: 'flex w-full justify-between py-[11px]',
                head_row: 'flex w-full justify-between py-[11px] mb-7',
                nav_button_previous: 'absolute left-10',
                nav_button_next: 'absolute right-10',
                day: clsx(
                  'p-0 font-normal aria-selected:opacity-100 w-8 rounded-full h-8'
                ),
              }}
            />
          </div>
          <div className="col-span-2 flex flex-col gap-6 pt-4 h-full min-h-0">
            <h4 className="pl-7 shrink-0">Ώρα</h4>
            <TimeSlotSection
              currentSlots={daySlots}
              selectedSlots={state.calendarValues.selectedSlots}
              dispatch={dispatch}
              state={state}
              maxSelections={mode==="appointment" ? 1 : 3}
            />
          </div>
        </div>
        {mode==="form" && state?.calendarValues?.selectedSlots?.length > 0 && <div className='w-full flex flex-col gap-2'>
          <button className='text-sm text-[#D4002A] flex flex-row w-full justify-end pr-10' 
          onClick={()=>{
            dispatch({
              type: 'CLEAR_TIMESLOTS',
            })
          }}>Διαγραφή όλων</button>
        <div className='flex flex-wrap gap-2'>
          {state?.calendarValues?.selectedSlots?.map((slot,index) => {
            const d = new Date(slot.date + "T00:00:00");
            const formatted = `${format(d, "EEEE dd.MM", { locale: el })} ${slot.start} - ${slot.end}`;
            return (
              <div key={index} className='flex flex-row gap-3 justify-between items-center border border-fadedgrey rounded-full py-3 pr-3 pl-5'>
                  <p className='text-lg font-bold whitespace-nowrap'>{formatted}</p>
                  <button onClick={()=>{
                    dispatch({
                      type: 'REMOVE_TIMESLOT',
                      value: slot,
                    })
                  }}
                  className="px-[5px] text-grenite bg-powdergrey rounded-full">
                    🞩
                  </button>
                </div>
              )
            })}
          </div>
        </div> }
      </div>
    </div>
  );
};
